import { CustomerDataSource } from "@redotech/redo-model/marketing/segments/segment-types";
import { memo, useMemo } from "react";
import { SegmentFieldSelectModal } from "../segment-field-select-modal";
import { AnyActivity, getCategories } from "./customer-activities";

interface SegmentActivitySelectModalProps {
  isOpen: boolean;
  onModalCloseRequested: () => void;
  activitySelected: (activity: AnyActivity) => void;
  initialSelectedActivity?: AnyActivity;
  availableDataSourcesForOrders?: CustomerDataSource[];
  availableDataSourcesForMarketing?: CustomerDataSource[];
}

export const SegmentActivitySelectModal = memo(
  function SegmentActivitySelectModal({
    isOpen,
    onModalCloseRequested,
    initialSelectedActivity,
    activitySelected,
    availableDataSourcesForOrders,
    availableDataSourcesForMarketing,
  }: SegmentActivitySelectModalProps) {
    // Use filtered categories if availableDataSources provided
    const categories = useMemo(
      () =>
        getCategories(
          availableDataSourcesForOrders,
          availableDataSourcesForMarketing,
        ),
      [availableDataSourcesForOrders, availableDataSourcesForMarketing],
    );

    return (
      <SegmentFieldSelectModal<AnyActivity>
        categories={categories}
        conditionSelected={activitySelected}
        initialSelectedCondition={initialSelectedActivity}
        isOpen={isOpen}
        onModalCloseRequested={onModalCloseRequested}
        submitText="Use activity"
        title="Select activity"
      />
    );
  },
);
